module.exports = __webpack_public_path__ + "static/media/7.f855f7f7.jpg";